<template>
  <div class="ia-view-shell">
    <DashboardNavbar
      :site-name="siteName"
      :site-logo-url="siteLogoUrl"
      :logo-text="logoText"
      :user-name="userName"
      :user-avatar="userAvatar"
      :user-username="currentUsername"
      :notification-count="0"
      :ia-mode="true"
      @ia-mode="router.back()"
      @profile="router.push('/profile')"
      @logout="handleLogout"
      @anotacoes="router.push('/anotacoes')"
    />
    <IAChatPanel />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import DashboardNavbar from '@/components/dashboard/DashboardNavbar.vue'
import IAChatPanel from '@/components/dashboard/IAChatPanel.vue'
import { sessionStore } from '@/store/session'
import { systemStore } from '@/store/system'
import { resolveUrl } from '@/utils/resolveUrl'
import { useSystemTheme } from '@/composables/useSystemTheme'

export default defineComponent({
  name: 'IAView',
  components: { DashboardNavbar, IAChatPanel },
  setup() {
    const router = useRouter()

    const userName    = computed(() => sessionStore.state.user?.name || '')
    const userAvatar  = computed(() => resolveUrl(sessionStore.state.user?.avatar || ''))
    const currentUsername = computed(() => sessionStore.state.user?.username || '')

    const cfg = computed(() => systemStore.state.config)

    const siteName   = computed(() => cfg.value.siteName || 'ObraTycoon')
    const siteLogoUrl = computed(() => cfg.value.siteLogoUrl || '')
    const logoText   = computed(() => {
      const t = cfg.value.logoType || 'default'
      if (t === 'default') return 'ObraTycoon by GusMachado'
      if (t === 'by-gus') return 'by GusMachado'
      return cfg.value.customLogoText || ''
    })

    const handleLogout = () => {
      sessionStore.logout()
      const username = sessionStore.state.user?.systemUsername || ''
      router.push(username ? `/login/${username}` : '/login')
    }

    onMounted(async () => {
      const { loadAndApply } = useSystemTheme()
      await Promise.all([
        loadAndApply(),
        systemStore.refreshFlags()
      ])
      if (!systemStore.isFeatureEnabled('ia')) {
        router.replace('/home')
      }
    })

    return { router, userName, userAvatar, currentUsername, siteName, siteLogoUrl, logoText, handleLogout }
  }
})
</script>

<style scoped>
.ia-view-shell {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
</style>
